import React from 'react';
import BlockWithNItems from '../block-with-n-items/block-with-n-items';
import TitleDividedWithDescriptionAndImage from '../title-divided-with-description-and-image/title-divided-with-description-and-image';
import TitleDivided from '../title-divided/title-divided';
import TitleWithDescription from '../title-with-description/title-with-description';
import './heading-with-main-and-use-cases.scss';

function HeadingWithMainAndUseCases({ content, type = 'home' }) {
  const titleDividedClassName = type === 'solutions' ? 'vertical' : 'bottom';
  return (
    <>
      <div className='heading-with-main-and-use-cases wrapper-fluid'>
        <TitleDivided content={content.header} className={`title-divided-padding-${titleDividedClassName}`} />
        <TitleDividedWithDescriptionAndImage
          content={content.main_case}
          extraContentClassName={` main-case type-${type}`}
        />
      </div>
      <BlockWithNItems items={content.use_cases}>
        <TitleWithDescription extraClassName={` type-${type}`} />
      </BlockWithNItems>
    </>
  );
}

export default HeadingWithMainAndUseCases;
